var map = {
	"./dxctj-1000.jpg": "5cbb",
	"./dxctj-2000.jpg": "97bb",
	"./dxctj-3000.jpg": "0caf",
	"./dxctj-4000.jpg": "21a6",
	"./dxctj-5000.jpg": "bd2e",
	"./dxctj-6000.jpg": "688b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "81c3";